import React from 'react';

import {
  AssignmentFilterTypes,
  AssignmentFilterOptions,
} from 'features/assignment/enums';
import { AssignmentFilters } from 'features/assignment/AssignmentsFilter';
import { getSelectedFilterValues } from 'utils/filterUtils';
import { CustomerSearchResponseModel } from 'api/backofficeApiClient';
import SelectWithLoading from 'hocs/withLoading/SelectWithLoading';

import styles from './CustomerFilter.module.less';

type Props = {
  filters: AssignmentFilters;
  onChange: (data: AssignmentFilters) => void;
  customers: CustomerSearchResponseModel[];
  isCustomersLoaded: boolean;
};

export default function CustomerFilter(props: Props) {
  const { filters, onChange, customers, isCustomersLoaded } = props;

  const handleFilterChange =
    (type: AssignmentFilterTypes) => (customers: string[]) => {
      const selectedFilterValues = getSelectedFilterValues(
        customers,
        AssignmentFilterOptions.All,
      );

      onChange({
        ...filters,
        [type]: selectedFilterValues,
      });
    };

  return (
    <SelectWithLoading
      isLoading={!isCustomersLoaded}
      className="full-width"
      value={filters[AssignmentFilterTypes.Customer]}
      mode="multiple"
      placeholder="Select a customer"
      onChange={handleFilterChange(AssignmentFilterTypes.Customer)}
      showSearch
      optionFilterProp="label"
    >
      {isCustomersLoaded && (
        <>
          <SelectWithLoading.Option
            value={AssignmentFilterOptions.All}
            label={AssignmentFilterOptions.All}
          >
            {AssignmentFilterOptions.All}
          </SelectWithLoading.Option>
          {customers.map(
            ({
              customerId,
              companyName,
              additionalInvoiceName,
            }: CustomerSearchResponseModel) => (
              <SelectWithLoading.Option
                key={customerId}
                value={customerId || ''}
                label={`${companyName || ''} ${
                  additionalInvoiceName || ''
                }`.trim()}
              >
                <div>
                  <div>{companyName}</div>
                  {additionalInvoiceName && (
                    <div className={styles.additionalInvoiceName}>
                      {additionalInvoiceName}
                    </div>
                  )}
                </div>
              </SelectWithLoading.Option>
            ),
          )}
        </>
      )}
    </SelectWithLoading>
  );
}
